import { scale } from '@scripts/gds';
import { themeColor } from '@scripts/themes/cssVars';

export const scrollbarStyles = {
    narrow: {
        scrollbarGutter: 'stable',
        '::-webkit-scrollbar': {
            width: 3,
            backgroundColor: themeColor.middleBackground,
            '&-thumb': {
                backgroundColor: themeColor.textMiddle,
                borderRadius: 30,
            },
        },
    },
    wide: {
        scrollbarGutter: 'stable',
        '::-webkit-scrollbar': {
            width: 5,
            backgroundColor: themeColor.middleBackground,
            '&-thumb': {
                backgroundColor: themeColor.textMiddle,
                borderRadius: 30,
            },
        },
    },
};

export const filterTitleStyles = {
    fontSize: '16px',
    fontWeight: 500,
    marginBottom: '12px',
    color: themeColor.textBlack,
};

export const showAllButtonStyles = {
    marginTop: scale(2),
    padding: 0,
    fontWeight: 500,
    fontSize: '14px',
    color: themeColor.green,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
        color: themeColor.greenHover,
    },
};

export const filterCountStyles = {
    color: themeColor.textLight,
    marginLeft: scale(1),
    height: '2px',
    display: 'inline-flex',
    alignItems: 'center',
};
